import { render, staticRenderFns } from "./CenteredCard.vue?vue&type=template&id=323be410&scoped=true"
import script from "./CenteredCard.vue?vue&type=script&lang=js"
export * from "./CenteredCard.vue?vue&type=script&lang=js"
import style0 from "./CenteredCard.vue?vue&type=style&index=0&id=323be410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323be410",
  null
  
)

export default component.exports